export default {
  SET_USER_PROFILE: 'setUserProfile',
};
